/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { getComparator, stableSort, getTimeZoneDate } from "../../services/helpers";
import { useMediaQuery } from "@mui/material";
import { Card, CardContent } from "../ui/card";
import { Badge } from "../ui/badge";
import ViewAttachments from "../../app/IssueManagement/IssueDetails/ViewAttachments";
import AuthContext from "../../hooks/authContext";

const ThemeTablen = (props) => {
  const [state, setState] = useState({
    order: "asc",
    orderBy: "",
    page: 0,
    rowsPerPage: 10,
  });
  const isMobile = useMediaQuery('(max-width:767px)');
  const auth = useContext(AuthContext);
  const isLandscape = useMediaQuery('(min-width: 771px) and (max-width: 940px)');

  useEffect(() => {
    setState({ ...state, page: 0 });
  }, [props, props?.filterBy]);


  const handleChangePage = (event, newPage) => {
    setState({ ...state, page: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    let size = parseInt(event.target.value, 10);
    setState({ ...state, page: 0, rowsPerPage: size });
  };

  const { rows, hidePagination } = props;
  let rowsList = rows?.length > 0 ? rows : [];
  const { order, orderBy, page, rowsPerPage } = state;
  const finalData = !hidePagination
    ? stableSort(rowsList, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      )
    : stableSort(rowsList, getComparator(order, orderBy));

  
    const emailAddresses = finalData[0]?.email || [];
    const inactiveEmails = finalData[0]?.inactive?.map(data => data.email) || [];

const sortedEmails = emailAddresses
.map((email, index) => ({
  email,
  isInactive: inactiveEmails.includes(email),
  originalIndex: index, // Preserve the original index
}))
.sort((a, b) => {
  // Sort inactive emails to the end, keep the original order within groups
  if (a.isInactive !== b.isInactive) {
    return a.isInactive - b.isInactive;
  }
  return a.originalIndex - b.originalIndex;
});

const IssueStatusBadge = ({ status }) => {
  const getBadgeStyles = () => {
    switch (status) {
      case "Escalate" :
        return "bg-blue-100 text-blue-800 hover:bg-blue-100";
      case "Open":
        return "bg-yellow-100 text-yellow-800 hover:bg-yellow-100";
      case "Resolved":
        return "bg-green-100 text-green-800 hover:bg-green-100";
      case "Closed":
        return "bg-gray-100 text-gray-800 hover:bg-gray-100";
      default:
        return "bg-gray-100 text-gray-800 hover:bg-gray-100";
    }
  };

  return (
    <Badge className={`font-medium ${getBadgeStyles()}`} variant="outline">
      {status?.charAt(0).toUpperCase() + status?.slice(1)}
    </Badge>
  );
};
  const IssuePriorityBadge = ({ priority }) => {
    const getBadgeStyles = () => {
      switch (priority) {
        case "High":
          return "bg-red-100 text-red-800 hover:bg-red-100";
        case "urgent":
          return "bg-orange-100 text-orange-800 hover:bg-orange-100";
        case "Medium":
          return "bg-yellow-100 text-yellow-800 hover:bg-yellow-100";
        case "Low":
          return "bg-green-100 text-green-800 hover:bg-green-100";
        default:
          return "bg-gray-100 text-gray-800 hover:bg-gray-100";
      }
    };

    return (
      <Badge className={`font-medium ${getBadgeStyles()}`} variant="outline">
        {priority?.charAt(0).toUpperCase() + priority?.slice(1)}
      </Badge>
    );
  };
    const isInactive = finalData[0]?.inactive?.some((inactiveEmp) => inactiveEmp?.id === finalData[0]?.employee.id);
    const closedBy = finalData[0]?.closedBy ||  finalData[0]?.updatedBy; 
    const closeIssue = auth?.userProfile?.employees?.find((activeEmp) => activeEmp?.id === closedBy);

  return (
      <Card className="mv-10 bg-white dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
      <CardContent className="p-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-4">
            <div>
              <h3 className="text-sm font-medium text-gray-500 mb-4">Status</h3>
              <IssueStatusBadge status={finalData[0]?.status} />
            </div>
            
            <div>
              <h3 className="text-sm font-medium text-gray-500 mb-4">Issue #</h3>
              <p className="font-medium color-newBlack dark:text-white" style={{fontSize:"16px", fontWeight:"500"}}>{finalData[0]?.issuueId}</p>
            </div>
            
            <div>
              <h3 className="text-sm font-medium text-gray-500 mb-4">Client</h3>
              <p className="font-medium color-newBlack dark:text-white" style={{fontSize:"16px", fontWeight:"500"}}>{finalData[0]?.clientName}</p>
            </div>
            
            <div>
              <h3 className="text-sm font-medium text-gray-500 mb-4">Raised by</h3>
              <p  className="color-newBlack dark:text-white">{finalData[0]?.employeeName}</p>
            </div>

            {finalData[0]?.status === "Closed" && (
              <div>
                <h3 className="text-sm font-medium text-gray-500 mb-4">Closed By</h3>
                <p className="color-newBlack dark:text-white">{closeIssue?.firstName} {closeIssue?.lastName}</p>
              </div>
            )}
          </div>
          
          <div className="space-y-4">
            <div>
              <h3 className="text-sm font-medium text-gray-500 mb-4">Priority</h3>
              <IssuePriorityBadge priority={finalData?.[0]?.priority} />
            </div>
            
            <div>
              <h3 className="text-sm font-medium text-gray-500 mb-4">Date Opened</h3>
              <p className="font-medium color-newBlack dark:text-white" style={{fontSize:"16px", fontWeight:"500"}}>{getTimeZoneDate(finalData[0]?.openedOn, finalData[0]?.timeZone)}</p>
            </div>
            
            <div>
              <h3 className="text-sm font-medium text-gray-500 mb-4">Last Updated</h3>
              <p className="font-medium color-newBlack dark:text-white" style={{fontSize:"16px", fontWeight:"500"}}>{getTimeZoneDate(finalData[0]?.updatedAt, finalData[0]?.timeZone)}</p>
            </div>
            
            {finalData[0]?.status === "Closed" && (
              <div>
                <h3 className="text-sm font-medium text-gray-500 mb-4">Date Closed</h3>
                <p className="color-newBlack dark:text-white">{getTimeZoneDate(finalData[0]?.closedOn, finalData[0]?.timeZone)}</p>
              </div>
            )}
          </div>
        </div>
        
        <div className="mt-20">
          <div className={isMobile ? "d-flex flex-direction-column" : "d-flex flex-space-between flex-center"}>
          <div>
          <h3 className="text-sm font-medium text-gray-500 mb-8">Description</h3>
          <p className="text-gray-700 whitespace-pre-line  color-newBlack dark:text-white">{finalData[0]?.description}</p>

          <div className="mt-10">
            <ViewAttachments attachments={finalData[0]?.attachments}/>
          </div>
          </div>
          <div className="width50">
          {sortedEmails?.map(({ email, isInactive }, index) => (
                <span
                  key={email}
                  style={{
                    color: isInactive ? "#9fa6b3" : "",
                    fontWeight: isInactive ? "lighter" : "normal",
                    marginRight: "2px",
                  }}
                >
                  {email}
                  {index < sortedEmails?.length - 1 && ", "} 
                </span>
              ))}
          </div>
          </div>
        </div>
      </CardContent>
    </Card>
    // <>
    //   {!isMobile && !isLandscape && (
    //     <div className="mainresp">
    //       <div className="leftc">
    //         <div className="textl"><span>Status</span>{finalData[0]?.status}</div>
    //         <div className="textl issueWrap"><span>Issue#</span>{finalData[0]?.issuueId}</div>
    //         <div className="textl"><span>Client Name</span>{finalData[0]?.clientName}</div>
    //         <div className="textl" style={{ color: isInactive ? "#9fa6b3" : "" }}><span>Raise by</span>{finalData[0]?.employeeName}</div>
    //       </div>
    //       <div className="rightc">
    //         <div className="textl"><span>Date Opened</span>{getTimeZoneDate(finalData[0]?.openedOn, finalData[0]?.timeZone)}</div>
    //         <div className="textl"><span>Last Updated</span>{getTimeZoneDate(finalData[0]?.updatedAt, finalData[0]?.timeZone)}</div>
    //         <div className="textl"><span>Priorty</span>{finalData[0]?.priority}</div>
    //         <div className="textl"><span>Esclated</span>{finalData[0]?.escalated_to_admin ? "Yes" : "No"}</div>
            
    //         <div className="textl">
    //           {sortedEmails.map(({ email, isInactive }, index) => (
    //             <span
    //               key={email}
    //               style={{
    //                 color: isInactive ? "#9fa6b3" : "",
    //                 fontWeight: isInactive ? "lighter" : "normal",
    //                 marginRight: "2px",
    //               }}
    //             >
    //               {email}
    //               {index < sortedEmails.length - 1 && ", "} 
    //             </span>
    //           ))}
    //         </div>
    //       </div>
    //     </div>
    //   )}
    //   {(isMobile || isLandscape) &&
    //     <div className="mainresp d-flex flex-direction-column">
    //       <div className="d-flex flex-space-between mb-10">
    //         <span className="theameColors fw-bold">Status</span>
    //       <div className="clientsummry theameVColors">{finalData[0]?.status}</div>
    //       </div>
    //       <div className=" d-flex flex-space-between mv-10">
    //         <span className="theameColors fw-bold">Issue#</span>
    //         <div className="clientsummry theameVColors">{finalData[0]?.issuueId}</div>
    //       </div>
    //       <div className="d-flex flex-space-between mv-10">
    //         <span className="theameColors fw-bold">Client Name</span>
    //         <div className="clientsummry theameVColors">{finalData[0]?.clientName}</div>
    //       </div>
    //       <div className="d-flex flex-space-between mv-10">
    //         <span className="theameColors fw-bold">Raise by</span>
    //         <div className="clientsummry theameVColors" style={{ color: isInactive ? "#9fa6b3" : "" }}>{finalData[0]?.employeeName}</div>
    //       </div>
    //       <div className="d-flex flex-space-between mv-10">
    //         <span className="theameColors fw-bold">Date Opened</span>
    //         <div className="clientsummry theameVColors">{getTimeZoneDate(finalData[0]?.openedOn, finalData[0]?.timeZone)}</div>
    //       </div>
    //       <div className="d-flex flex-space-between mv-10">
    //         <span className="theameColors fw-bold">Last Updated</span>
    //         <div className="clientsummry theameVColors">{getTimeZoneDate(finalData[0]?.updatedAt, finalData[0]?.timeZone)}</div>
    //       </div>
    //       <div className="d-flex flex-space-between mv-10">
    //         <span className="theameColors fw-bold">Priorty</span>
    //         <div className="clientsummry theameVColors">{finalData[0]?.priority}</div>
    //       </div>
    //       <div className="d-flex flex-space-between mv-10">
    //       <span className="theameColors fw-bold">Esclated</span>
    //       <div className="clientsummry theameVColors">{finalData[0]?.escalated_to_admin ? "Yes" : "No"}</div>
    //       </div>
    //       <div className="d-flex mv-10">
    //       <div className="theameVColors">
    //         {sortedEmails.map(({ email, isInactive }, index) => (
    //           <span
    //             key={email}
    //             style={{
    //               color: isInactive ? "#9fa6b3" : "",
    //               fontWeight: isInactive ? "lighter" : "normal",
    //               marginRight: "2px",
    //             }}
    //           >
    //             {email}
    //             {index < sortedEmails.length - 1 && ", "}
    //           </span>
    //         ))}
    //       </div>
    //       </div>
    //     </div>
    //   }

    //   {!hidePagination && rows?.length > 0 && (
    //     <TablePagination
    //       rowsPerPageOptions={[5, 10, 25]}
    //       component="div"
    //       count={rows?.length}
    //       rowsPerPage={rowsPerPage}
    //       page={page}
    //       onPageChange={handleChangePage}
    //       onRowsPerPageChange={handleChangeRowsPerPage}
    //     />
    //   )}
    // </>
  );
};
export default ThemeTablen;
